export enum VeteranAutoType {
  VETERANBIL = "VETERANBIL",
  VETERANMOPED = "VETERANMOPED",
  VETERANMOTORSYKKEL = "VETERANMOTORSYKKEL",
}
